import { Vue } from 'vue-property-decorator';
import APP_CONST from '@/constants/AppConst';
import APP_UTILITIES from '@/utilities/commonFunctions';
import { Cart } from '@/Model/checkout/cart/types';

/**
 * Interface to the persistent cart in local storage.
 *
 * In order to support storing carts for multiple partner accounts simultaneously,
 * we store carts in a map keyed by the partner account slug.
 */
export default class CartLocalStorageUtilities extends Vue {
  public static getLocalStorageCart(): Cart | undefined {
    const cartMap = JSON.parse(localStorage.getItem(APP_CONST.CART_LOCAL_STORAGE_KEY) || '{}');
    return cartMap[APP_UTILITIES.accountSlug];
  }

  public static setLocalStorageCart(cart: Cart) {
    const cartMap = JSON.parse(localStorage.getItem(APP_CONST.CART_LOCAL_STORAGE_KEY) || '{}');
    cartMap[APP_UTILITIES.accountSlug] = cart;
    localStorage.setItem(APP_CONST.CART_LOCAL_STORAGE_KEY, JSON.stringify(cartMap));
  }

  public static removeLocalStorageCart() {
    const cartMap = JSON.parse(localStorage.getItem(APP_CONST.CART_LOCAL_STORAGE_KEY) || '{}');
    delete cartMap[APP_UTILITIES.accountSlug];
    localStorage.setItem(APP_CONST.CART_LOCAL_STORAGE_KEY, JSON.stringify(cartMap));
  }
}